/**
 * Created by mark on 23/01/2018.
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import CurriculumService from '../../../../services/curriculums-services.js';
import ContentService from '../../../../services/content-service.js';
import ModuleService from '../../../../services/screens-service.js';
import ModulesStore from '../../../../store/screen-store.js';
import ContentStore from '../../../../store/content-store.js';
import VocabObject from '../../../content-target-verb.js';
import Translation from '../../../../store/internationalization-store.js';
import { Button , Panel , Breadcrumb , Col  , Row  } from 'react-bootstrap';
import IntelStore from "../../../../store/internationalization-store.js"

class VerbContent extends React.Component {

    constructor(props) {
        super();
        this.props = props;

        this.history = [];
        this.catalogUID = null;
        this.props.data.verbSections = this.props.data.verbSections || [];
        this.curriculums = this.props.data.language.curriculums;
        this.state = {catalog:ContentStore.getVerbs(this.catalogUID)};
    }

    getCurriculum(){
        let curriculums = Object.keys(this.curriculums).map(function(k) { return this.curriculums[k] }.bind(this));
        return curriculums[0]
    }


    componentDidMount() {

        this.fetchModules(null , true , <FormattedMessage id={ 'ui-000' } defaultMessage={ 'Verb Bank' }/>);


        ContentStore.on('ON_VERBS_FETCH'  , () => {

            console.log('verbs fetched')
            this.setState({
                catalog:ContentStore.getVerbs(this.catalogUID),
            })

            console.log(ContentStore.getVerbs(this.catalogUID))
        })
    }


    findHistoryIndex(screenUID){

        for(var idx = 0 ; idx < this.history.length; idx++ )
        {
            if(this.history[idx].screenID == screenUID ) return idx ;
        }

        return this.history.length;
    }

    fetchModules(screenUID , isRoot , crumbTranslation){


        this.history = this.history.slice(0, this.findHistoryIndex(screenUID));
        this.catalogUID = null;

        ModuleService.getVerbModules(screenUID ,  8 , this.props.data.language.ietf).then(function(response){

            if(isRoot)
            {
                this.history = [];
            }

            this.history.push({name:crumbTranslation , screenID:screenUID})
            this.setState({modules:response.verbs , catalog:ContentStore.getVerbs(this.catalogUID)});
        }.bind(this));
    }

    onSelect(catalogUID , crumbTranslation , screenID){
        this.history.push({name:crumbTranslation , screenID:screenID})
        this.catalogUID = catalogUID
        ContentService.fetchVerbs(catalogUID , this.props.data.language.ietf);
    }

    addSection()
    {
        var add = true;

        for(var index = 0 ; index < this.props.data.verbSections.length; index++)
        {
            if(this.props.data.verbSections[index] == this.catalogUID)
            {
                add = false;
                this.props.data.verbSections.splice(index , index + 1)
            }
        }

        if(add) this.props.data.verbSections.push(this.catalogUID);

        let crumb = this.history[this.history.length - 2];
        this.fetchModules(crumb.screenID , false , crumb.name);

    }

    isAdded(){
        return this.props.data.verbSections.indexOf(this.catalogUID) > -1;
    }

    render(){

        if(!this.state.modules) return null;

        let breadcrumbs = this.history.map(function(crumb , index){


            let onClick = (index != this.history.length - 1) ? this.fetchModules.bind(this , crumb.screenID , false , crumb.name) : function(){}
            return <Breadcrumb.Item active={!(index != this.history.length - 1)} onClick={onClick} >{crumb.name}</Breadcrumb.Item>

        }.bind(this));

        let modules = this.state.modules.map(function(module){

            console.log(module)
            let onClick = !module.isLast  ? this.fetchModules.bind(this , module.verbUid , false , module.title) : this.onSelect.bind(this , module.verbUid , module.title , module.verbUid );
            let icon    = !module.isLast  ?  <i className=" zmdi-hc-2x zmdi zmdi-chevron-right"></i> : <i className="zmdi-hc-2x zmdi zmdi-format-list-bulleted"></i>;

            if(this.props.data.verbSections.indexOf(module.verbUid) > -1)
            {
                icon = <i className=" zmdi-hc-2x zmdi zmdi-check"></i>
            }

            return <Col md={3}>
                <div className="b-1 m-b-10"  onClick={onClick}>

                    <div  style={{width:'100%' , textAlign:'left'}} className="p-5 vert-center">
                        <p  style={{margin:0}}> {module.title}</p>
                    </div>
                    <div  style={{width:50}} className="p-10 vert-center">
                        {icon}
                    </div>
                </div>
            </Col>

        }.bind(this));

        var VocabObjects = [];


        for(var idx = 0 ; idx < this.state.catalog.verbs.length; idx++)
        {
            let vocabObject = this.state.catalog.verbs[idx];
            VocabObjects.push(<Col md={3}><VocabObject vocab={vocabObject}/></Col>);
        }


        var msg = !this.isAdded() ? <FormattedMessage id={ 'ui-000' } defaultMessage={ 'Add Section' }/> : <FormattedMessage id={ 'ui-000' } defaultMessage={ 'Remove Section' }/>
        return   <div>
            <Breadcrumb className="b-1">{breadcrumbs}<span className="pull-right"><FormattedMessage id={ 'ui-000' } defaultMessage={ 'Total Selected' }/> : {this.props.data.verbSections.length}</span></Breadcrumb>
            <Panel collapsible expanded={VocabObjects.length == 0}>
                <Row>
                    {modules}
                </Row>
            </Panel>
            <Panel collapsible expanded={VocabObjects.length > 0}>
                <Row>
                    <Col md={12}>
                        <Button block onClick={this.addSection.bind(this)} bsStyle={!this.isAdded() ? 'primary' : 'danger'}>
                            <b>{msg}</b>
                        </Button>
                    </Col>
                </Row>
                <Row className="p-t-5">
                    {VocabObjects}
                </Row>
            </Panel>
        </div>


    }

}

export default {
    name: <FormattedMessage id={ 'ui-000' } defaultMessage={ 'Verb Bank' }/>,
    title:null,
    removePadding:true,
    navigationTop:true,
    onSubmit: function (done){

        if(this.props.data.verbSections.length == 0)
        {
            return done(new Error(IntelStore.getTranslation("ui-673")));
        }

        done();

    },
    component: VerbContent
}


// WEBPACK FOOTER //
// ./src/components/wizard/homework-steps/verb-builder/verb-builder.js